import { callApi } from '@local_modules/generic/fetch'

export default class DataEntities {
  constructor () {
    console.log('DataEntities constructor')
    this.appAccountId = null
    this.data = null
  }

  async initForAccount (appAccountId) {
    this.appAccountId = appAccountId
    await this.loadData(this.appAccountId)
  }

  async loadData (appAccountId) {
    const apiUrl = '/api/pg-financials/data/:appAccountId/pg-accounting-orgs'
    const data = await callApi(apiUrl, {
      appAccountId
    })
    // console.log('api data', data)
    this.data = data
    return data
  }
}
